import React from 'react'
 const LineArrow = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="9.999" height="13.348" viewBox="0 0 9.999 13.348">
  <path id="Path_26" data-name="Path 26" d="M5,0l5,4.789-1.667,1.6L6.111,4.257v9.091H3.889V4.257L1.667,6.385,0,4.789Z" transform="translate(0)" fill="#529a00"/>
  </svg>
)
export default LineArrow;
